import { DatePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import trLocale from 'date-fns/locale/tr';
import { formatDateForApi, InputformatDate, InputformatJustDate, parseAndFormatDate } from '../../../../util/DateUtil';
import { Box, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { isValid, parse } from 'date-fns';


const DateComponent = ({
    kriterId,
    kriterAdi,
    parentKriterId,
    parentSecenekId = null,
    selKriterler,
    bagliOlunanKriterId,
    bagliOlunanKriterSecenekId,
    zorunlu = false,
    onChange }) => {

    const [visiable, setVisiable] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [lastValue, setLastValue] = useState("");

    useEffect(() => {
        if (bagliOlunanKriterId) {
            const isVisible =
                bagliOlunanKriterSecenekId &&
                selKriterler &&
                selKriterler[bagliOlunanKriterId]?.value === bagliOlunanKriterSecenekId;
            setVisiable(!!isVisible);
        } else {
            setVisiable(true);
        }
    }, [bagliOlunanKriterId, bagliOlunanKriterSecenekId, selKriterler]);

    if (visiable === false) return <></>;

    let initialDate = selKriterler[kriterId]?.value ? new Date(selKriterler[kriterId]?.value) : null;

    // If the initial date is invalid, set it to null
    if (initialDate && !isValid(initialDate)) {
        initialDate = null;
    }



    const handleInput = (e) => {
        const input = e.target;
        const currentValue = input.value;

        // If length decreased, it means user is deleting => don't format
        if (currentValue.length < lastValue.length) {
            setLastValue(currentValue);
            return; // don't reformat on delete
        }

        // Else format normally
        input.value = handleInputFormat(currentValue);
        setLastValue(input.value)
    };


    const handleInputFormat = (value) => {

        // Remove all non-digit characters
        let digits = value.replace(/\D/g, '');

        if (digits.length > 8) digits = digits.slice(0, 8);

        let formatted = '';
        if (digits.length >= 2) formatted += digits.slice(0, 2) + '.';
        else formatted += digits;

        if (digits.length >= 4) formatted += digits.slice(2, 4) + '.';
        else if (digits.length > 2) formatted += digits.slice(2);

        if (digits.length > 4) formatted += digits.slice(4);

        return formatted;
    };



    const isFullyValidDate = (input) => {
        if (!input) return false;

        // If it's already a Date object and valid
        if (input instanceof Date) return isValid(input);

        // If it's a string like "dd.MM.yyyy", try parsing
        if (typeof input === 'string') {
            const parsed = parse(input, 'dd.MM.yyyy', new Date());
            return isValid(parsed);
        }

        return false;
    };




    return (
        <Box sx={{ pt: 2 }}>
            <LocalizationProvider dateAdapter={AdapterDateFns} locale={trLocale}>
                <DatePicker
                    key={kriterId}
                    label={
                        <span>
                            {kriterAdi}
                            {zorunlu && <span style={{ color: "red", fontSize: "1.3rem", fontWeight: "bold" }}> *</span>}
                        </span>
                    }
                    value={selKriterler[kriterId]?.value ?? null} // use value instead of defaultValue
                    onChange={(newValue) => {

                        if (isValid(newValue) && isFullyValidDate(newValue)) {
                            setHasError(false);
                            onChange(kriterId, InputformatJustDate(newValue));
                        } else {
                            onChange(kriterId, undefined);
                            setHasError(true);
                        }
                    }}
                    inputFormat="dd.MM.yyyy"
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            margin="dense"
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            error={hasError}
                            helperText={hasError ? 'Geçerli bir tarih giriniz (gg.aa.yyyy)' : ''}
                            inputProps={{
                                ...params.inputProps,
                                maxLength: 10,
                                onInput: handleInput,
                            }}
                        />
                    )}
                />
            </LocalizationProvider>
        </Box>
    );
};

export default DateComponent;
